import React from "react";
import { Container, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import Header from "../../Common/Header";
import { user_token } from "../../../_helpers/tokensStored";
import useAllAppliedCandidate from "./useAllAppliedCandidate";
import { useNavigate } from "react-router-dom";
import MainLayout from "../../Common/MainLayout";

export default (props) => {
  const userToken = user_token;

  const {
    loading,
    appliedCandidates,
    onBackClick,
    onViewCandidateProfileClick,
    onViewJobsDetail,
  } = useAllAppliedCandidate(props);

  return (
    <MainLayout pageName={"Applied Candidates"}>
      <div className="hiring-process-dashboard">
        {loading ? (
          <div className="d-flex justify-content-center align-items-center">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <>
            <div className="top bg-grey pb-4">
              <Container className="d-flex justify-content-between align-items-center">
                <div className="left">
                  <h2 className="text-dark">
                    <button className="border-0 bg-transparent mr-2">
                      <FontAwesomeIcon
                        icon={faAngleLeft}
                        className="text-primary"
                        onClick={onBackClick}
                      />
                    </button>
                    {userToken?.user &&
                      userToken.user.user_meta_info?.company_details &&
                      userToken.user.user_meta_info.company_details?.name}
                  </h2>
                </div>
                <a href="/create-job" className="btn btn-primary">
                  Create a new job
                </a>
              </Container>
            </div>
          </>
        )}

        <div className="container">
          <div className="d-flex align-items-center mt-4">
            <h4
              className="mb-4 mt-3 text-uppercase mr-3 flex-1"
              style={{ width: "230px" }}
            >
              All Applied Candidates
            </h4>
            <span className="partition border-bottom mb-2 w-100"></span>
          </div>
          <div className="job-listing">
            {Array.isArray(appliedCandidates) && appliedCandidates?.length ? (
              <div className="row">
                {appliedCandidates &&
                  Array.isArray(appliedCandidates) &&
                  appliedCandidates.map((data, index) => (
                    <div className="col-md-6 mb-4" key={index}>
                      <div className="d-flex flex-column h-100 p-4 bg-white border rounded-lg shadow-2 position-relative">
                        <div className="upper">
                          <div className="d-flex mb-3 align-items-start">
                            <img
                              src={
                                data?.candidate_profile_details &&
                                data.candidate_profile_details
                                  ?.user_meta_info &&
                                data.candidate_profile_details.user_meta_info
                                  ?.profile_image
                                  ? data?.candidate_profile_details &&
                                    data.candidate_profile_details
                                      ?.user_meta_info &&
                                    data.candidate_profile_details
                                      .user_meta_info?.profile_image
                                  : "/assets/images/building-placeholder.png"
                              }
                              alt="profile_image"
                              className="border-radius-10 mr-3"
                              style={{ width: "48px", height: "48px" }}
                            />
                            <div className="job-info flex-grow-1">
                              <h3
                                className=" mb-1 text-capitalize text-primary cursor-pointer"
                                onClick={() =>
                                  onViewCandidateProfileClick(data?.id)
                                }
                              >
                                {data?.candidate_profile_details &&
                                  data.candidate_profile_details
                                    ?.user_details &&
                                  data.candidate_profile_details.user_details
                                    ?.full_name}
                              </h3>
                              <p className="font-weight-medium text-grey-4 text-capitalize">
                                {data?.candidate_profile_details &&
                                  data.candidate_profile_details?.headline}
                              </p>
                            </div>
                          </div>
                          <p className="skills-list text-capitalize">
                            <span className="mr-2 font-weight-semi">
                              Skills:
                            </span>
                            {data?.candidate_profile_details &&
                            data.candidate_profile_details?.skills &&
                            Array.isArray(
                              data.candidate_profile_details?.skills
                            ) &&
                            data.candidate_profile_details.skills.length > 1 ? (
                              <>
                                {Array.isArray(
                                  data?.candidate_profile_details &&
                                    data.candidate_profile_details?.skills &&
                                    data.candidate_profile_details.skills
                                ) &&
                                  data?.candidate_profile_details &&
                                  data.candidate_profile_details?.skills &&
                                  data.candidate_profile_details.skills
                                    .slice(0, 6)
                                    .map((skill) => (
                                      <span className="skill text-muted">
                                        {skill?.skill_name}
                                      </span>
                                    ))}
                                <p className="text-muted d-inline-block">
                                  {data?.candidate_profile_details &&
                                  data.candidate_profile_details?.skills &&
                                  Array.isArray(
                                    data.candidate_profile_details?.skills
                                  ) &&
                                  data.candidate_profile_details.skills.length >
                                    6
                                    ? "..."
                                    : null}
                                </p>
                              </>
                            ) : (
                              <>Not Specified</>
                            )}
                          </p>
                        </div>
                        <p className="text-grey-4 text-capitalize pb-3">
                          {data?.candidate_profile_details &&
                            Array.isArray(
                              data.candidate_profile_details?.work_experience
                            ) &&
                            data.candidate_profile_details?.work_experience.map(
                              (item) =>
                                item?.currently_working_here === true ? (
                                  <>
                                    <span className="mr-2 font-weight-semi text-dark-2">
                                      Currently Working:
                                    </span>
                                    {item?.company_name}
                                  </>
                                ) : null
                            )}
                        </p>
                        <div className="d-flex justify-content-between align-items-center job-bottom mt-4 pt-3 mt-auto border-top">
                          <p className="text-grey-4">
                            Applied for{" "}
                            <span
                              className="text-primary text-underline cursor-pointer"
                              onClick={() =>
                                onViewJobsDetail(
                                  data?.job_details && data.job_details?.id
                                )
                              }
                            >
                              {data?.job_details && data.job_details?.title}
                            </span>
                          </p>
                          <button
                            className="btn btn-primary py-2 mr-2"
                            onClick={() =>
                              onViewCandidateProfileClick(data?.id)
                            }
                          >
                            View
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            ) : (
              <div className="msg-bg text-white p-3 border-6 mb-3 mt-4 d-flex align-items-center justify-content-center mb-2 mw-50 mx-auto">
                <p className="mb-0">
                  <FontAwesomeIcon
                    icon={faCircleInfo}
                    className="text-white mr-2"
                  />
                  No Applied Candidates Found
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </MainLayout>
  );
};
